// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Specialization of cast result against a shape
 *
 * C++ `JPH::RayCastResult`.
 */
class RayCastResult internal constructor(internal val rayCastResultHandle: NativePointer, owned: Boolean = false) : BroadPhaseCastResult(JphRayCastResult_asBroadPhaseCastResult(rayCastResultHandle), owned), AutoCloseable {
    constructor() : this(JphRayCastResult_create(), owned = true)

    override fun close() =
        closeOnce { JphRayCastResult_destroy(rayCastResultHandle) }

    /** Sub shape ID of shape that we collided against */
    var subShapeID2: SubShapeID
        get() = SubShapeID(JphRayCastResult_GetSubShapeID2(rayCastResultHandle))
        set(value) = JphRayCastResult_SetSubShapeID2(rayCastResultHandle, value.value)
}
